:host{display:flex;margin:0 -7px}
/*# sourceMappingURL=row.component.css.map */
